// Central PocketBase client for the app
// You can override the base URL via REACT_APP_PB_URL
import PocketBase from 'pocketbase';

const baseUrl = process.env.REACT_APP_PB_URL || 'https://versionnet.infocolab.online';

const pb = new PocketBase(baseUrl);
pb.autoCancellation(false);

// Example: attach an auth state change logger (optional)
// pb.authStore.onChange(() => {
//   console.log('PB auth changed', pb.authStore.isValid, pb.authStore.model);
// });

export default pb;
